import React, { useState, useEffect } from 'react';
import { useTranslation } from "react-i18next";
import { formatInTimeZone } from 'date-fns-tz';
import { parse } from 'date-fns';
import SignalsICO from "../assets/svg/signals-icon.svg";

const Chat = ({ isOpen, toggleChat, information }) => {
    const { t } = useTranslation();
    const [message, setMessage] = useState('');
    const [charCount, setCharCount] = useState(0);
    const [userID, setUserId] = useState(localStorage.getItem('id') || 0);
    const [messages, setMessages] = useState([]);
    const [translatedMessages, setTranslatedMessages] = useState([]);
    const [loading, setLoading] = useState(false);


    useEffect(() => {
        getInformation();
    }, [isOpen]);


    const getInformation = () => {
        setLoading(true);
        fetch(`${process.env.REACT_APP_BACKEND}/chat?signals=${information.id}&limit=4`, {
            method: "GET",
            headers: {
                Authorization: `${localStorage.getItem("token")}`,
            },
        })
            .then((response) => response.json())
            .then((response) => {
                setMessages(response?.data?.items); // Guardar los mensajes en el estado
                setLoading(false);
            })
            .catch((error) => {
                console.log(error);
                setLoading(false);
            });
    };
    // Función para enviar el mensaje
    const sendMessage = () => {
        if (message.trim() !== '') {
            // Crea un objeto FormData para enviar el mensaje
            const formData = new FormData();
            formData.append('signal', information?.id);
            formData.append('message', message);

            fetch(`${process.env.REACT_APP_BACKEND}/chat`, {
                method: 'POST',
                headers: {
                    Authorization: `${localStorage.getItem("token")}`,
                },
                body: formData,
            })
                .then((response) => response.json())
                .then((data) => {
                    getInformation()
                    setMessage(''); // Limpiar el campo después de enviar
                })
                .catch((error) => {
                    console.error('Error al enviar el mensaje:', error);
                });
        }
    };


    // Función para manejar el cambio en el textarea
    const handleMessageChange = (e) => {
        setMessage(e.target.value);
        setCharCount(e.target.value.length);
    };

    // Función que detecta cuando se presiona Enter
    const handleKeyPress = (e) => {
        if (e.key === 'Enter') {
            e.preventDefault(); // Evitar que se añada una nueva línea en el textarea
            sendMessage(); // Enviar el mensaje
        }
    };

    const formatDate = (dateString) => {
        // Convertir la fecha de cadena "YYYY-MM-DD HH:mm:ss" a un objeto Date
        const date = parse(dateString, 'yyyy-MM-dd HH:mm:ss', new Date());

        // Formatear la fecha con la zona horaria UTC
        return formatInTimeZone(date, 'UTC', 'hh:mm a');
    };

    const isUserAllowed = ["1", "8", "12", "3160"].includes(userID);


    const translateMessage = async (message, targetLang) => {
        if (targetLang === 'Spanish') {
            return message;
        }
        const apiKey = "AIzaSyDx5MOtvhYLJzCz01kEPMtPr-VM0Oq-hkc"; // Coloca tu clave de API aquí
        const url = `https://translation.googleapis.com/language/translate/v2/`;

        const languageMap = {
            "English": "en",
            "French": "fr",
            "Italian": "it",
            "Portuguese": "pt",
            // Agrega más idiomas si es necesario
        };

        // Verifica si el idioma solicitado está en el mapeo
        const targetLanguageCode = languageMap[targetLang];

        // Si el idioma no es válido, devuelve el mensaje original
        if (!targetLanguageCode) {
            console.error("Unsupported target language:", targetLang);
            return message;
        }
        const formData = new FormData();
        formData.append("q", message);
        formData.append("target", targetLanguageCode);
        formData.append("format", "text");
        formData.append("key", apiKey);
        try {
            const response = await fetch(url, {
                method: "POST",
                body: formData,
            });

            const data = await response.json();

            if (response.ok) {
                return data.data.translations[0].translatedText;
            } else {
                console.error("Error in translation response:", data.error);
                return message; // Si ocurre un error, devuelve el mensaje original
            }
        } catch (error) {
            console.error("Error translating message:", error);
            return message; // Si ocurre un error, devuelve el mensaje original
        }
    };

    useEffect(() => {
        const translateMessages = async () => {
            const translated = await Promise.all(
                messages.map(async (msg) => {
                    const translatedMessage = await translateMessage(msg.message, localStorage.getItem("lng"));
                    return {
                        ...msg,
                        message: translatedMessage,
                    };
                })
            );
            console.log(translated)
            setTranslatedMessages(translated);
        };

        translateMessages();
    }, [messages, localStorage.getItem("lng")]);


    return (
        <>
            {/* Contenedor del chat, con transiciones para abrir y cerrar */}
            <div
                className={`z-30 fixed top-0 right-0 w-full lg:w-1/3 h-screen bg-popup-signals text-white p-4 rounded-lg transition-all duration-300 ease-in-out ${isOpen ? 'transform translate-x-0' : 'transform translate-x-full'}`}
            >
                <button onClick={toggleChat} className="text-white p-1 absolute right-0 top-0 rounded-lg bg-black">
                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" className="size-6">
                        <path stroke-linecap="round" stroke-linejoin="round" d="M6 18 18 6M6 6l12 12" />
                    </svg>
                </button>
                <div className='bg-zinc-800 h-full mt-1'>
                    <img
                        src={information?.header}
                        alt={information?.name}
                        className="rounded-lg"
                    />
                    <div className="rounded-lg px-2 flex flex-row justify-between">
                        <div className="flex text-white flex-row items-center">
                            <img src={SignalsICO} alt={"Icon Signals"} />
                            <h3 className="uppercase text-sm">{information?.name || "CTX Signals"}</h3>
                        </div>
                        <div className="flex text-white flex-row items-center">
                            <a href={information?.url || ""} target="_blank" rel="noreferrer">
                                <button className="flex gap-2 flex-row rounded-2xl m-2 border-2 border-[#383838] p-2">
                                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" className="size-6">
                                        <path stroke-linecap="round" stroke-linejoin="round" d="M13.5 6H5.25A2.25 2.25 0 0 0 3 8.25v10.5A2.25 2.25 0 0 0 5.25 21h10.5A2.25 2.25 0 0 0 18 18.75V10.5m-10.5 6L21 3m0 0h-5.25M21 3v5.25" />
                                    </svg>
                                    {t("_FREE._VER")}
                                </button>
                            </a>
                        </div>
                    </div>
                    {/* Messages */}
                    <div className="flex flex-col gap-4 overflow-y-auto h-2/4 p-4 bg-zinc-700">
                        <h1 className="text-xl font-bold">CHAT</h1>
                        {translatedMessages.map((msg, index) => (
                            <div key={index} className="flex flex-row items-center gap-2">
                                <div className="bg-gray-700 p-2 rounded-full text-sm font-semibold">{msg.name}</div>
                                <p className="text-sm text-gray-300">{msg.message}</p>
                                <span className="text-xs text-gray-500">{formatDate(msg.created)}</span>
                            </div>
                        ))}
                    </div>
                    {/* Message Input */}
                    <div className="relative m-4">
                        <textarea
                            className={`w-full h-16 p-4 bg-gray-700 text-white rounded-lg pr-16 ${!isUserAllowed ? "cursor-not-allowed" : ""
                                }`}
                            placeholder="Write Message.."
                            value={message}
                            onChange={handleMessageChange}
                            onKeyPress={handleKeyPress}
                            disabled={!isUserAllowed}
                        />
                        {/* Botón dentro del textarea, alineado a la derecha */}
                        <button
                            className={`absolute right-2 bottom-10 bg-popup-signals p-2 rounded-full text-black mx-auto ${!isUserAllowed ? "cursor-not-allowed opacity-50" : ""
                                }`}
                            onClick={sendMessage}
                            disabled={!isUserAllowed}
                        >
                            <svg
                                xmlns="http://www.w3.org/2000/svg"
                                fill="none"
                                viewBox="0 0 24 24"
                                strokeWidth="1.5"
                                stroke="currentColor"
                                className="size-6"
                            >
                                <path
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                    d="M6 12 3.269 3.125A59.769 59.769 0 0 1 21.485 12 59.768 59.768 0 0 1 3.27 20.875L5.999 12Zm0 0h7.5"
                                />
                            </svg>
                        </button>
                        <div className="flex justify-between items-center mt-2">
                            <span className="text-xs text-gray-500">{charCount} characters</span>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default Chat;
